import { render, staticRenderFns } from "./_base-modal-layout.vue?vue&type=template&id=c1d39502&scoped=true"
import script from "./_base-modal-layout.vue?vue&type=script&lang=js"
export * from "./_base-modal-layout.vue?vue&type=script&lang=js"
import style0 from "./_base-modal-layout.vue?vue&type=style&index=0&id=c1d39502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d39502",
  null
  
)

export default component.exports